export default __webpack_public_path__ + "static/media/glasses-blue.c8917792.svg";